import { render, staticRenderFns } from "./GroupTable.vue?vue&type=template&id=fd788a5c&scoped=true&"
import script from "./GroupTable.vue?vue&type=script&lang=js&"
export * from "./GroupTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupTable.vue?vue&type=style&index=0&id=fd788a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd788a5c",
  null
  
)

export default component.exports